import { lang } from '@lang';

import { Feature, FeatureHoookParams } from '..';
import { selectAccessoryDropdown, setAccessoryDropDown, useAppDispatch, useAppSelector } from '@state';

type AccessoryFeatureParams = FeatureHoookParams;
export const useShowAccessoryDropdownFeature = (_params: AccessoryFeatureParams = {}): Feature<boolean> => {
	const dispatch = useAppDispatch();
	const accessoryDropdown = useAppSelector(selectAccessoryDropdown);

	const [disabled, tooltip, label] = (() => {
		if (!accessoryDropdown) return [false, lang.accessories.tooltip.addAccessory, lang.accessories.label.accessory];
		return [true, lang.accessories.tooltip.hideAccessory, lang.accessories.label.hideAccessory];
	})();

	return {
		name: 'show-accessory-dropdown',
		label,
		shortcut: '',
		tooltip,
		icon: (props = {}) => <></>,
		disabled,
		value: true,
		hidden: false,
		handler: () => {
			dispatch(setAccessoryDropDown(!accessoryDropdown));
		}
	};
};
